import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { NgxCurrencyDirective } from 'ngx-currency';

import { UiModule } from '@lockton-apps/shared/ui/lui';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DynamicTablesTypeComponent } from './dynamic-tables.component';
import {
  JoinPipe,
  MapPipe,
  RoundPipe,
} from '@lockton-apps/shared/util/ng-lodash';
import {
  ClearOnFocusDirective,
  FormGroupValidationDirective,
  provideAdditionalValidationMessages,
} from '@lockton-apps/shared/util/form-utils';
import { MaterialModule } from '@lockton-apps/material';
import { DynamicTablesSectionSummaryPipe } from './pipes/dynamic-tables-section-summary.pipe';
import { DynamicTablesSectionFieldIdsPipe } from './pipes/dynamic-tables-section-field-ids.pipe';

@NgModule({
  declarations: [
    DynamicTablesTypeComponent,
    DynamicTablesSectionSummaryPipe,
    DynamicTablesSectionFieldIdsPipe,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskDirective,
    FormlyModule.forChild({
      types: [
        {
          name: 'dynamic-tables',
          component: DynamicTablesTypeComponent,
        },
      ],
    }),
    UiModule,
    MatIconModule,
    MatButtonToggleModule,
    RoundPipe,
    FormGroupValidationDirective,
    MaterialModule,
    ClearOnFocusDirective,
    NgxMaskPipe,
    NgxCurrencyDirective,
    MapPipe,
    JoinPipe,
  ],
  providers: [
    provideAdditionalValidationMessages({
      generic: {
        min: "Can't be smaller than { min }",
        max: "Can't be bigger than { max }",
      },
    }),
  ],
})
export class DynamicTablesModule {}
